import PATH_CONFIG from "./path-config";
import requestAPI from "./request";

export default class AccountService {

    static getAccountsByCriteria(params) {

        if(params.q === ""){
            delete params.q;
        }

        if(params.isActive === null){
            delete params.isActive;
        }

        const options = {
            method: "GET",
            params
        };

        return requestAPI(PATH_CONFIG.ACCOUNTS, options)
            .then(response => {

                let numPages = Math.ceil(
                    response.data.count / params.itemsPerPage
                );
                return {
                    accounts: response.data.accounts,
                    total_accounts: response.data.count,
                    total_pages: numPages,
                };
            });
    }

    static getAccountById(accountId) {
        const requestPath = `${PATH_CONFIG.ACCOUNTS}/${accountId}`;
        const options = {
            method: "GET"
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }

    static subscriptionName(subscription) {
        let prodName = subscription.connectedProducts[0].productName.replace(/ /g, "");
        console.log("PRODNAME" + prodName);
        return `${subscription.unitId}-${subscription.e0Number}-${prodName}`;
    }

    static createAccount(account) {
        const options = {
            method: "POST",
            data: account
        };

        return requestAPI(PATH_CONFIG.ACCOUNTS, options)
            .then(response => {
                return response;
            });
    }

    static saveSubscription(accountId, sub) {
        const requestPath = `${PATH_CONFIG.ACCOUNTS}/${accountId}/${this.getSubId(sub)}`;
        const options = {
            method: "PUT",
            data: sub
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }

    static getSubId(sub) {
        let subId = sub.uuid;
        if (!subId) subId = `${sub.unitId}-${sub.connectedProducts[0].productId}`;
        return subId;
    }

    static addKey(accountId, sub) {
        const requestPath = `${PATH_CONFIG.ACCOUNTS}/${accountId}/${this.getSubId(sub)}/credentials`;
        const options = {
            method: "POST",
            data: {}
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }

    static revokeKey(accountId, sub, key) {
        const requestPath = `${PATH_CONFIG.ACCOUNTS}/${accountId}/${this.getSubId(sub)}/credentials/${key}?action=revoke`;
        const options = {
            method: "PUT"
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }

    static updateAccount(account) {
        const requestPath = `${PATH_CONFIG.ACCOUNTS}/${account.id}`;
        const options = {
            method: "PUT",
            data: account
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }
}


// WEBPACK FOOTER //
// ./src/services/account-service.js